// import { Checkbox, Col, Input, InputRef, Select, Typography } from 'antd';
import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// import { addCardProps } from '../../actions';
// import {
//   AnswerDetailsInput,
//   AnswerOptionInput,
//   QuestionType,
// } from '../../graphql/api';
// import { IState } from '../../graphql/types';
// import { mockupData } from '../FeedCards/utils';
// import { formInputLength, handleInputChange } from '../utils';
// import { CardFormField } from './CardFormField';

import styles from './CardForm.module.css';

// const defaultAnsDetails = {
//   answerOptions: [],
//   correctAnswerIndex: undefined,
//   userAnswerIsCorrect: null,
//   userAnswer: null,
// };
// const { Option } = Select;

const QuizForm: React.FC<{ validationFailed: boolean; saving: boolean }> = ({
  validationFailed,
  saving,
}) => {
  // const dispatch = useDispatch();
  // const ref = React.createRef<InputRef>();
  // const question = useSelector<IState, string>(
  //   state => state.cardProps?.question ?? ''
  // );
  // const questionType = useSelector<IState, QuestionType>(
  //   state => state.cardProps?.questionType ?? mockupData.quiz.questionType
  // );
  // const answerDetails = useSelector<IState, AnswerDetailsInput>(
  //   state => state.cardProps?.answerDetails ?? defaultAnsDetails,
  //   () => false
  // );
  // const answerOptions = useSelector<IState, AnswerOptionInput[]>(
  //   state => state.cardProps?.answerDetails?.answerOptions ?? [],
  //   () => false
  // );
  // const correctAnswer = useSelector<IState, null | number | undefined>(
  //   state => state.cardProps?.answerDetails?.correctAnswerIndex,
  //   () => false
  // );
  // const quizHasCorrectAnswer = useSelector<IState, null | boolean | undefined>(
  //   state => state.cardProps?.questionHasCorrectAnswer,
  //   () => false
  // );

  // const isNewFeedCard = useSelector<IState, null | boolean | undefined>(
  //   state => !state.cardProps?.id,
  //   () => false
  // );

  // const updateType = React.useCallback(
  //   e => {
  //     dispatch(
  //       addCardProps(
  //         'questionType',
  //         e.target.checked
  //           ? QuestionType.openEndedTextResponse
  //           : QuestionType.multipleChoiceSingleResponse
  //       )
  //     );
  //     if (e.target.checked) {
  //       dispatch(addCardProps('answerDetails', { userAnswer: null }));
  //       dispatch(addCardProps('questionHasCorrectAnswer', false));
  //     } else {
  //       dispatch(addCardProps('answerDetails', defaultAnsDetails));
  //     }
  //   },
  //   [dispatch]
  // );

  // const updateItem = React.useCallback(
  //   index => e => {
  //     if (e.target.value) {
  //       const tmpAnsDetails = answerDetails;
  //       if (tmpAnsDetails.answerOptions?.[index]) {
  //         tmpAnsDetails.answerOptions[index].text = e.target.value;
  //       }
  //       dispatch(addCardProps('answerDetails', tmpAnsDetails));
  //     } else {
  //       const tmpAnsDetails = answerDetails;
  //       tmpAnsDetails.answerOptions?.splice(index, 1);
  //       tmpAnsDetails.answerOptions?.forEach((answer, i) => {
  //         // Reordering indices
  //         answer.index = i;
  //         answer.sortOrder = index;
  //       });
  //       if (
  //         tmpAnsDetails.correctAnswerIndex ??
  //         -1 > (tmpAnsDetails.answerOptions?.length ?? 0) - 1
  //       ) {
  //         if (tmpAnsDetails.correctAnswerIndex) {
  //           tmpAnsDetails.correctAnswerIndex--;
  //         }
  //       }
  //       dispatch(addCardProps('answerDetails', tmpAnsDetails));
  //     }
  //   },
  //   [dispatch, answerDetails]
  // );

  // const createItem = React.useCallback(
  //   (e, index) => {
  //     answerDetails.answerOptions = answerOptions;
  //     const tmpAnsDetails = answerDetails;
  //     const newAnswer = {
  //       index,
  //       sortOrder: index,
  //       text: e.target.value,
  //     };
  //     if (
  //       tmpAnsDetails.answerOptions &&
  //       tmpAnsDetails.answerOptions.length - 1 < index
  //     ) {
  //       tmpAnsDetails.answerOptions.push(newAnswer);
  //     } else {
  //       tmpAnsDetails.answerOptions![index] = newAnswer;
  //     }
  //     dispatch(addCardProps('answerDetails', tmpAnsDetails));
  //   },
  //   [dispatch, answerDetails, answerOptions]
  // );

  // const changeCorrectAnswer = React.useCallback(
  //   (answer: number | boolean) => {
  //     const tmpAnsDetails = answerDetails;
  //     if (typeof answer === 'number') {
  //       tmpAnsDetails.correctAnswerIndex = answer - 1;
  //       dispatch(addCardProps('answerDetails', tmpAnsDetails));
  //     } else {
  //       tmpAnsDetails.correctAnswerIndex = answer ? undefined : 0;
  //       dispatch(addCardProps('questionHasCorrectAnswer', !answer));
  //       dispatch(addCardProps('answerDetails', tmpAnsDetails));
  //     }
  //   },
  //   [answerDetails, dispatch]
  // );

  // const defaultList = React.useCallback(() => {
  //   const items: any[] = [];
  //   for (let i = 0; i < 2; i++) {
  //     items.push(
  //       <Input
  //         key={i}
  //         ref={ref}
  //         value={''}
  //         onChange={e => createItem(e, i)}
  //         style={i === 0 ? { marginBottom: '3px' } : undefined}
  //         className={`modal-form-input ${
  //           validationFailed ? styles.notValidInput : ''
  //         }`}
  //         disabled={saving}
  //       />
  //     );
  //   }
  //   return items;
  // }, [ref, createItem, validationFailed, saving]);

  return (
    <div className={styles.formWrapper}>
      {/* <Col span={24}>
        <CardFormField
          name="quizQuestion"
          fieldLabel="Question"
          tooltip="The question you would like to ask your listeners."
          defaultValue={question}
          customValidator={e => formInputLength(e.target.value, 300)}
          customRules={[
            { max: 300, message: 'Limit of 300 characters exceeded' },
          ]}
        >
          <Input
            autoFocus
            className="modal-form-input"
            onChange={handleInputChange(value =>
              dispatch(addCardProps('question', value))
            )}
            disabled={saving}
          />
        </CardFormField>
      </Col>
      {questionType === QuestionType.openEndedTextResponse && !isNewFeedCard && (
        <Col span={24}>
          <CardFormField
            name="quizType"
            fieldLabel="Open ended question"
            tooltip="Check this box to allow your listeners to write a short response rather than selecting from multiple choice. Open-ended questions do not have a correct answer."
            defaultValue={questionType}
            required={false}
          >
            <Checkbox
              checked={questionType === QuestionType.openEndedTextResponse}
              onChange={updateType}
              disabled={saving}
            />
          </CardFormField>
        </Col>
      )}
      {questionType === QuestionType.multipleChoiceSingleResponse && (
        <>
          <Typography className={styles.formText}>Answers</Typography>
          <Col span={24}>
            <div style={{ maxHeight: '69pt', overflow: 'overlay' }}>
              {answerOptions.map((item, index) =>
                answerOptions.length - 1 === index ? (
                  <Input
                    autoFocus
                    key={index}
                    className="modal-form-input list-item-input"
                    value={item.text}
                    onChange={e => {
                      if (e.currentTarget.value.length <= 60)
                        updateItem(index)(e);
                    }}
                    disabled={saving}
                  />
                ) : (
                  <Input
                    key={index}
                    className={`modal-form-input list-item-input ${
                      answerOptions.length < 2 && validationFailed
                        ? styles.notValidInput
                        : ''
                    }`}
                    value={item.text}
                    onChange={e => {
                      if (e.currentTarget.value.length <= 60)
                        updateItem(index)(e);
                    }}
                    disabled={saving}
                  />
                )
              )}
              {answerOptions.length === 0 ? (
                <>{defaultList()}</>
              ) : answerOptions.length < 4 ? (
                <Input
                  ref={ref}
                  className={`modal-form-input list-item-input ${
                    answerOptions.length < 2 && validationFailed
                      ? styles.notValidInput
                      : ''
                  }`}
                  value={''}
                  placeholder={
                    answerOptions.length > 1
                      ? 'You can add another answer if you want'
                      : undefined
                  }
                  onChange={e => createItem(e, answerOptions.length)}
                  disabled={saving}
                />
              ) : undefined}
            </div>
          </Col>
          {!!answerOptions.length && (
            <Col span={24}>
              <CardFormField
                name="quizHasAnswer"
                fieldLabel="Quiz has correct answer"
                tooltip="Check this box if your quiz has a correct answer. Your listeners will be able to see whether or not they chose the correct answer after they answer your quiz."
                required={false}
              >
                <Checkbox
                  checked={!!quizHasCorrectAnswer}
                  onChange={() => changeCorrectAnswer(!!quizHasCorrectAnswer)}
                  disabled={saving}
                />
              </CardFormField>
            </Col>
          )}
          {!!quizHasCorrectAnswer && (
            <Col span={24}>
              <Typography>Which answer is correct?</Typography>
              <Select
                onChange={e => changeCorrectAnswer(e as number)}
                value={correctAnswer ? correctAnswer + 1 : 1}
                disabled={saving}
              >
                {answerOptions.map((_, index) => (
                  <Option value={index + 1} key={index}>
                    {index + 1}
                  </Option>
                ))}
              </Select>
            </Col>
          )}
        </>
      )} */}
    </div>
  );
};

export default QuizForm;
